import { queryOptions } from '@tanstack/react-query';
import { accessApi } from './access-api';

/**
 * Grants change only when an admin edits the policy — refetch at most every
 * few minutes (and on window focus once stale). A stale grant is cosmetic:
 * the gateway still enforces every request.
 */
const PERMISSIONS_STALE_TIME_MS = 5 * 60_000;

export const accessKeys = {
  all: ['access'] as const,
  mine: () => [...accessKeys.all, 'mine'] as const,
};

export const accessQueries = {
  mine: () =>
    queryOptions({
      queryKey: accessKeys.mine(),
      queryFn: () => accessApi.mine(),
      staleTime: PERMISSIONS_STALE_TIME_MS,
      retry: false,
    }),
};
